import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";

export default function PhotoArchive() {
  return (
    <Container className="mb-6">
      <article>
        <Header title="Fotoarkiv" lead="Informasjon om bruk av Statsforvalterens fotoarkiv." />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <p>Statsforvalternes fotoarkiv kan finnes her:</p>
              <p><a href="https://statsforvalteren.imageshop.no/">https://statsforvalteren.imageshop.no/</a></p>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
